import Req from '../../$axios';

const serviceModule = {
  // 关注
  subscriptionTask(params) {  //动作类型
    return Req({
      url: 'userAttention/subscriptionTask',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 取消
  unsubscribeTask(params) {  //动作类型
    return Req({
      url: 'userAttention/unsubscribeTask',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
};

export default {
  ...serviceModule
};
